<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row mb-5">
            <div class="col-12">
                <FormInput style="width: 96%; margin: auto" label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="base.nombre" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Apellidos" type="text" name="apellidos" id="apellidos" rules="required" v-model="base.apellidos" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="DNI" type="text" name="dni" id="dni" rules="required" v-model="base.dni" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Fecha de nacimiento" type="date" max="9999-12-31" name="fecha_nacimiento" id="fecha_nacimiento" rules="required" v-model="base.fecha_de_nacimiento" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Fecha de caducidad del DNI" type="date" max="9999-12-31" name="fecha_caducidad_dni" id="fecha_caducidad_dni" rules="required" v-model="base.fecha_de_caducidad_dni" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Teléfono" type="number" name="telefono" id="telefono" rules="required" v-model="base.telefono" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Email" type="email" name="email" id="email" rules="required" v-model="base.email" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mb-3 ml-3 mt-3">
                <Paises id="pais_de_nacimiento" :desactivar="!paso_activo ? true : false" :errors="errors" @rellenarPais="rellenarPais" style="width: 98%; margin: auto" v-on:selected="
                    (opt) => {
                        pais = opt;
                        base.pais_de_nacimiento = opt.id;
                    }
                " />
            </div>
            <div class="col-12 mb-3 ml-3 mt-3">
                <Provincias id="provincia_de_nacimiento" :desactivar="!paso_activo ? true : false" :errors="errors" style="width: 98%; margin: auto" :pais="pais.id" :provincia="provincia"
                    v-on:selected="
                        (opt) => {
                            provincia = opt;
                            base.provincia_de_nacimiento = opt.id;
                        }
                " />
            </div>
            <div class="col-12 mb-3 ml-3 mt-3">
                <Locations style="width: 98%; margin: auto" id="localidad_de_nacimiento" :desactivar="!paso_activo ? true : false" :provincia="provincia" :location_id="base.localidad_de_nacimiento" :errors="errors"
                    v-on:selected="
                        (opt) => {
                            base.localidad_de_nacimiento = opt.id;
                        }
                " />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Nacionalidad" type="text" name="nacionalidad" id="nacionalidad" rules="required" v-model="base.nacionalidad" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Dirección" type="text" name="direccion" id="direccion" rules="required" v-model="base.direccion" :disabled="!paso_activo" />
            </div>
            <div class="col-12 mt-3">
                <FormInput style="width: 96%; margin: auto" label="Club de procedencia (Si aplica)" type="text" name="club_de_procedencia" id="club_de_procedencia" rules="" v-model="base.club_de_procedencia" :disabled="!paso_activo" />
            </div>
            <label class="ml-4 pl-3 mt-3">CATEGORÍA BASE</label>
            <div class="col-12">
                <ValidationProvider name="categoria_base" id="categoria_base" rules="required" v-slot="{ errors }">
                    <multiselect 
                        :disabled="!paso_activo"
                        v-model="base.categoria_base"
                        id="categoria"
                        placeholder="Categoría Base"
                        :class="'col-12 ml-4' + (errors[0] ? 'is-invalid' : '')"
                        style="width: 94%"
                        label="name"
                        track-by="id" 
                        :multiple="false" 
                        :options="categorias_bases"
                        v-on:select="(selectedOpt) => $emit('selected', selectedOpt)">
                        <template slot="option" slot-scope="props">
                            <div class="option__desc"><span class="option__title">{{ props.option.name }}</span> - <span class="option__small">{{ props.option.precio | formatear_precio }}</span></div>
                        </template>
                    </multiselect>
                    <span v-if="errors[0]" class="invalid-feedback ml-3 mb-4 text-xs" style="width: 98%; display: block;">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="col-12" v-if="equipos">
                <label class="ml-4 pl-3 mt-3">Equipos</label>
                <ValidationProvider name="equipo" id="equipo" rules="required" v-slot="{ errors }">
                    <multiselect 
                        :disabled="!paso_activo"
                        v-model="base.equipo"
                        id="equipo"
                        placeholder="Equipo"
                        :class="'col-12 ml-4' + (errors[0] ? 'is-invalid' : '')"
                        style="width: 94%"
                        label="nombre"
                        track-by="id" 
                        :options="equipos">
                    </multiselect>
                    <span v-if="errors[0]" class="invalid-feedback ml-3 mb-4 text-xs" style="width: 98%; display: block;">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <label class="ml-4 pl-3 mt-3">LATERALIDAD</label>
            <div class="col-12">
                <ValidationProvider name="lateralidad" id="lateralidad" rules="required" v-slot="{ errors }">
                    <multiselect 
                        :disabled="!paso_activo"
                        v-model="base.lateralidad"
                        id="lateralidad"
                        placeholder="Lateralidad"
                        :class="'col-12 ml-4' + (errors[0] ? 'is-invalid' : '')"
                        style="width: 94%;"
                        :multiple="false" 
                        :options="lateralidades">
                    </multiselect>
                    <span v-if="errors[0]" class="invalid-feedback ml-3 mb-4 text-xs" style="width: 98%; display: block;">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="col-12 text-right mt-4">
                <Button @click="volver()" name="button" class="mr-2" :disabled="!paso_activo">ATRÁS</Button>
                <Button id="terminar-paso-1" type="submit" name="button" :disabled="!paso_activo">CONTINUAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import Provincias from "../../../common/forms/Provincias.vue";
import Locations from "../../../common/forms/Locations.vue";
import Paises from "../../../common/forms/Paises.vue";

export default {
    props: ["base", "paso_activo"],
    data() {
        return {
            errors: [],
            error: this.$route.query.error,
            provincia: null,
            pais: { id: 0 },
            nacionalidad: "Española",
            selected: null,
            items: null,
            categorias_bases: [],
            equipos: null,
            lateralidades: ['Diestro', 'Zurdo', 'Ambidiestro']
        };
    },
    created() {
        this.base.lista_id = this.lista_id;

        this.$store
            .dispatch(this.config.getVuexAlias("back.bases.categorias.precios"), this.base)
            .then(res => {
                this.categorias_bases = res.data.data;
                if (this.categorias_bases && this.categorias_bases.length == 1) {
                    this.base.categoria_base = this.categorias_bases[0];
                }
            });

        this.getEquipos();

        if (!this.base.provincia_de_nacimiento) {
            this.provincia = this.teatro.provincia;
        } else {
            this.provincia = this.base.provincia_de_nacimiento;
        }
    },
    methods: {
        rellenarPais(pais) {
            this.base.pais_de_nacimiento = pais.nombre;
        },
        terminar() {
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro
                }
            }
            this.base['teatro_id'] = this.teatro.id;
            this.base['equipo_id'] = this.base['equipo'] ? this.base['equipo']['id'] : null;

            this.base['taquilla'] = 1;
            if (typeof this.base['provincia_de_nacimiento'] == 'object' && typeof this.base['localidad_de_nacimiento'] == 'object') {
                this.base['provincia_de_nacimiento'] = this.base['provincia_de_nacimiento']['id'];
                this.base['localidad_de_nacimiento'] = this.base['localidad_de_nacimiento']['id'];
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {
                this.base.session_id = res.data.session_id;
            });

            this.$emit("terminado");
        },
        getEquipos() {
            var params = {
                lista_id: this.lista_id,
                filters: {}
            };

            this.$store.dispatch(this.config.getVuexAlias("back.bases.equipos.index"), params).then(res => {
                this.equipos = res.data.data;
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.terminar();
            }
        },
        volver() {
            this.$emit('volver');
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_id() {
            return this.$route.params.lista_id;
        }
    },
    components: { Paises, Locations, Provincias },
};
</script>

<style>
    .multiselect > .multiselect__tags {
        background-color: white;
        border: none;
    }

    .multiselect {
        border-bottom: 1px solid black;
        width: 98%;
    }

    @media (max-width: 992px) {
        #localidad_de_nacimiento {
            width: 92.6%;
        }

        #categoria {
            width: 60%;
        }

        .multiselect {
            width: 98%;     
        }
    }
</style>